import { Outlet } from "react-router-dom";

import { FilterLevelProvider } from "./filter-level/filter-level.context";
import './level.scss';

export function Level() {
  return (
    <div id="ShellLevel" className="level">
       <FilterLevelProvider>
        <Outlet />
      </FilterLevelProvider>
    </div>
  );
}

export default Level;
